import { useState } from "react";
import { faqs } from "@/mocks/platforms";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>("faq-1");

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">FAQ</span>
            <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl">关于榜单的常见问题</h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              关于排名口径、更新节奏和上榜方式，我们把问得最多的几个问题整理在这里。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 px-4 py-2.5 text-sm rounded-md bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line"></i>
              还有疑问？联系我们
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((item) => {
                const open = openId === item.id;
                return (
                  <div key={item.id}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={open}
                        onClick={() => setOpenId(open ? "" : item.id)}
                        className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer"
                      >
                        <span className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                          {item.question}
                        </span>
                        <span
                          className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                            open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                          }`}
                        >
                          <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                        </span>
                      </button>
                    </h3>
                    <div className={`overflow-hidden transition-all duration-300 ${open ? "max-h-[320px] pb-5" : "max-h-0"}`}>
                      <p className="text-sm md:text-base leading-relaxed text-foreground-600 pr-10">{item.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}